<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#fff' },
  strokeColor: { type: String, default: '#fff' },
})
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.31019 20.3833C6.72239 21.1112 7.50383 21.6023 8.4 21.6023H15.6C16.9255 21.6023 18 20.5278 18 19.2023V8.69351L6.31019 20.3833ZM17.7879 3.81445C17.4113 2.98174 16.5733 2.40234 15.6 2.40234H8.4C7.07452 2.40234 6 3.47686 6 4.80234V15.6023L17.7879 3.81445ZM13.2 18.0023C13.2 18.6651 12.6627 19.2023 12 19.2023C11.3373 19.2023 10.8 18.6651 10.8 18.0023C10.8 17.3396 11.3373 16.8023 12 16.8023C12.6627 16.8023 13.2 17.3396 13.2 18.0023Z"
      :fill="fillColor"
    />
    <line
      x1="21.0364"
      y1="1.83561"
      x2="1.83642"
      y2="21.0356"
      :stroke="strokeColor"
      stroke-width="1.8"
    />
  </svg>
</template>
